export default __webpack_public_path__ + "assets/models/59b6055ad08ed6cc41a0147994bf9977.glb";